<template>
<v-container fluid grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12 mb-2 v-if="getFiltersChips">
        <Filters v-bind:filters="getFilters"></Filters>
      </v-flex>

      <v-flex xs12>
        <v-card>
          <v-card-text class="pa-0 grey lighten-2 mb-3">
            <Counters v-bind:counters="['hashtags']" v-bind:filters="getFilters"></Counters>
          </v-card-text>
        </v-card>
      </v-flex>
       <v-flex xs6>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Hashtag Cloud</div>
              <v-dialog style="float: right" v-model="hashtagCloudDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">Hashtag Cloud</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullHashtagCloud'], 'FullHashtagCloud')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn icon dark @click.native="hashtagCloudDialog = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullHashtagCloud" ref="FullHashtagCloud" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center" v-if="hashtagCloudDialog">
                    <HashtagCloud v-bind:options="{}" v-bind:filters="getFilters"></HashtagCloud>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn style="float: right; width: 30px" flat icon color="primary" class="mx-0" @click.stop="snap($refs['HashtagCloud'], 'HashtagCloud')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="height:450px" class="d-flex justify-center align-center">
              <v-card-text id="HashtagCloud" ref="HashtagCloud" style="height: 100%">
                <HashtagCloud v-bind:options="{}" v-bind:filters="getFilters"></HashtagCloud>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs6>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Hashtag Graph</div><span class="caption pa-3" style="color:grey;margin-bottom: 0;line-height: 50px" v-html="sortByGraph"></span>
              <v-dialog style="float: right" v-model="hashtagsRelatedGraphChartDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">Hashtag Graph</p>
                    <v-menu v-model="dialogMenu" :close-on-content-click="false" class="right" v-if="hashtagsRelatedGraphChartDialog">
                      <v-btn
                        @click.stop="dialogMenu = true" 
                        slot="activator"
                        color="primary"
                        dark
                        fab
                        small
                        class="float: right" 
                        flat
                        style="margin-top:4px; margin-right:0px">
                        <v-icon>fas fa-sliders-h </v-icon>
                      </v-btn>
                      <v-card>
                        <v-list>
                          <v-list-tile>
                           <v-btn-toggle
                              overflow
                              hide-details
                              mandatory
                              v-model="sortGraph"
                              class="transparent right"
                              style="float: left;margin: 6px 10px; box-shadow:none;-webkit-box-shadow:none">
                              <v-tooltip top>
                              <span>Sort by most Tweeted</span>
                              <v-btn slot="activator" flat color="blue lighten-2" @click.stop="" value="_tweet_count">
                                <v-icon>fab fa-twitter</v-icon>
                              </v-btn>
                              </v-tooltip>
                              <!--<v-tooltip top>
                                <span>Sort by most Retweeted</span>
                                <v-btn slot="activator" flat color="green lighten-2" @click.stop="" value="_retweet_count">
                                  <v-icon>fas fa-retweet</v-icon>
                                </v-btn>
                              </v-tooltip>
                              <v-tooltip top>
                                <span>Sort by most Favorited</span>
                                <v-btn slot="activator" flat color="red lighten-2" @click.stop="" value="_favorite_count">
                                  <v-icon>fas fa-heart</v-icon>
                                </v-btn>
                              </v-tooltip>
                              <v-tooltip top>
                                <span>Sort by most Replied</span>
                                <v-btn slot="activator" flat color="blue lighten-1" @click.stop="" value="_reply_count">
                                  <v-icon>fas fa-comment</v-icon>
                                </v-btn>
                              </v-tooltip>
                              <v-tooltip top>
                                <span>Sort by most Quoted</span>
                                <v-btn slot="activator" flat color="teal lighten-2" @click.stop="" value="_quote_count">
                                  <v-icon>fas fa-quote-right</v-icon>
                                </v-btn>
                              </v-tooltip>-->
                              <v-tooltip top>
                                <span>Sort by Latest</span>
                                <v-btn slot="activator" flat color="orange lighten-2" @click.stop="" value="_created_at">
                                  <v-icon>fas fa-calendar</v-icon>
                                </v-btn>
                              </v-tooltip>
                            </v-btn-toggle>
                          </v-list-tile>
                        </v-list>
                        <v-divider></v-divider>
                          <v-menu offset-y class="left pl-3 pt-2">
                            <v-btn
                              slot="activator"
                              color="primary"
                              dark
                              v-model="hashtagLimit">
                              Limit: {{hashtagLimit}}
                            </v-btn>
                            <v-list>
                              <v-list-tile
                                v-for="item in hashtagLimits"
                                :key="item"
                                @click="hashtagLimit = item">
                                <v-list-tile-title>{{ item }}</v-list-tile-title>
                              </v-list-tile>
                            </v-list>
                          </v-menu>
                          <v-btn-toggle
                            overflow
                            hide-details
                            mandatory
                            v-model="layout"
                            class="transparent pr-3 pt-2"
                            style="float: right;margin: 6px 8px; box-shadow:none;-webkit-box-shadow:none">
                            <v-tooltip top>
                            <span>Force layout</span>
                            <v-btn slot="activator" flat color="gray lighten-2" @click.stop="" value="force">
                              <v-icon>fas fa-code-branch</v-icon>
                            </v-btn>
                          </v-tooltip>
                          <v-tooltip top>
                            <span>Circular layout</span>
                            <v-btn slot="activator" flat color="gray lighten-2" @click.stop="" value="circular">
                              <v-icon>fas fa-spinner</v-icon>
                            </v-btn>
                          </v-tooltip>
                        </v-btn-toggle>
                        <v-btn-toggle
                          overflow
                          hide-details
                          v-model="singles"
                          class="transparent px-2 pt-2"
                          style="float: right;margin: 6px 8px; box-shadow:none;-webkit-box-shadow:none">
                          <v-tooltip top>
                            <span>Singlets</span>
                            <v-btn slot="activator" flat color="gray lighten-2" @click.stop="" value="singles">
                              <v-icon>far fa-dot-circle </v-icon>
                            </v-btn>
                          </v-tooltip>
                        </v-btn-toggle>
                        <v-card-actions style="clear:both;">
                          <v-spacer></v-spacer>
                          <v-btn color="primary" flat @click="dialogMenu = false">Ok</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-menu>
                    <v-btn style="float: right;" flat icon color="primary" class="mx-0" @click.stop="snap($refs['FullHashtagsRelatedGraphChart'], 'FullHashtagsRelatedGraphChart')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="hashtagsRelatedGraphChartDialog = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullHashtagsRelatedGraphChart" ref="FullHashtagsRelatedGraphChart" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center;padding-top:20px" v-if="hashtagsRelatedGraphChartDialog">
                    <HashtagsRelatedGraphChart style="height:100%" v-bind:options="{sortBy: this.sortGraph, order: 'DESC', layout: this.layout, pageSize: hashtagLimit}" v-bind:filters="getFilters"></HashtagsRelatedGraphChart>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn style="float: right; width: 30px" flat icon color="primary" class="mx-0" @click.stop="snap($refs['HashtagsRelatedGraphChart'], 'HashtagsRelatedGraphChart')">
                <v-icon>get_app</v-icon>
              </v-btn>
              <v-menu v-model="menu" :close-on-content-click="false" class="right">
                <v-btn
                  @click.stop="menu = true" 
                  slot="activator"
                  color="primary"
                  dark
                  fab
                  small
                  class="float: right" 
                  flat
                  style="margin-top:4px; margin-right:0px">
                  <v-icon>fas fa-sliders-h </v-icon>
                </v-btn>
                <v-card>
                  <v-list>
                    <v-list-tile>
                     <v-btn-toggle
                        overflow
                        hide-details
                        mandatory
                        v-model="sortGraph"
                        class="transparent right"
                        style="float: left;margin: 6px 10px; box-shadow:none;-webkit-box-shadow:none">
                        <v-tooltip top>
                        <span>Sort by most Tweeted</span>
                        <v-btn slot="activator" flat color="blue lighten-2" @click.stop="" value="_tweet_count">
                          <v-icon>fab fa-twitter</v-icon>
                        </v-btn>
                        </v-tooltip>
                        <!--<v-tooltip top>
                          <span>Sort by most Retweeted</span>
                          <v-btn slot="activator" flat color="green lighten-2" @click.stop="" value="_retweet_count">
                            <v-icon>fas fa-retweet</v-icon>
                          </v-btn>
                        </v-tooltip>
                        <v-tooltip top>
                          <span>Sort by most Favorited</span>
                          <v-btn slot="activator" flat color="red lighten-2" @click.stop="" value="_favorite_count">
                            <v-icon>fas fa-heart</v-icon>
                          </v-btn>
                        </v-tooltip>
                        <v-tooltip top>
                          <span>Sort by most Replied</span>
                          <v-btn slot="activator" flat color="blue lighten-1" @click.stop="" value="_reply_count">
                            <v-icon>fas fa-comment</v-icon>
                          </v-btn>
                        </v-tooltip>
                        <v-tooltip top>
                          <span>Sort by most Quoted</span>
                          <v-btn slot="activator" flat color="teal lighten-2" @click.stop="" value="_quote_count">
                            <v-icon>fas fa-quote-right</v-icon>
                          </v-btn>
                        </v-tooltip>-->
                        <v-tooltip top>
                          <span>Sort by Latest</span>
                          <v-btn slot="activator" flat color="orange lighten-2" @click.stop="" value="_created_at">
                            <v-icon>fas fa-calendar</v-icon>
                          </v-btn>
                        </v-tooltip>
                      </v-btn-toggle>
                    </v-list-tile>
                  </v-list>
          
                  <v-divider></v-divider>
          
                      <v-menu offset-y class="left pl-3 pt-2">
                        <v-btn
                          slot="activator"
                          color="primary"
                          dark
                          v-model="hashtagLimit">
                          Limit: {{hashtagLimit}}
                        </v-btn>
                        <v-list>
                          <v-list-tile
                            v-for="item in hashtagLimits"
                            :key="item"
                            @click="hashtagLimit = item">
                            <v-list-tile-title>{{ item }}</v-list-tile-title>
                          </v-list-tile>
                        </v-list>
                      </v-menu>

                      <v-btn-toggle
                        overflow
                        hide-details
                        mandatory
                        v-model="layout"
                        class="transparent pr-3 pt-2"
                        style="float: right;margin: 6px 8px; box-shadow:none;-webkit-box-shadow:none">
                        <v-tooltip top>
                            <span>Force layout</span>
                            <v-btn slot="activator" flat color="gray lighten-2" @click.stop="" value="force">
                              <v-icon>fas fa-code-branch</v-icon>
                            </v-btn>
                        </v-tooltip>
                        <v-tooltip top>
                          <span>Circular layout</span>
                          <v-btn slot="activator" flat color="gray lighten-2" @click.stop="" value="circular">
                            <v-icon>fas fa-spinner</v-icon>
                          </v-btn>
                        </v-tooltip>
                      </v-btn-toggle>
                      <v-btn-toggle
                        overflow
                        hide-details
                        v-model="singles"
                        class="transparent px-2 pt-2"
                        style="float: right;margin: 6px 8px; box-shadow:none;-webkit-box-shadow:none">
                        <v-tooltip top>
                          <span>Singlets</span>
                          <v-btn slot="activator" flat color="gray lighten-2" @click.stop="" value="singles">
                            <v-icon>far fa-dot-circle </v-icon>
                          </v-btn>
                        </v-tooltip>
                      </v-btn-toggle>
                  <v-card-actions style="clear:both;">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="menu = false">Ok</v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </div>
            <v-card style="height:450px">
              <v-card-text id="HashtagsRelatedGraphChart" ref="HashtagsRelatedGraphChart" style="height:100%">
                <HashtagsRelatedGraphChart style="height:100%" v-bind:options="{sortBy: this.sortGraph, order: 'DESC', layout: this.layout, pageSize: hashtagLimit}" v-bind:filters="getFilters"></HashtagsRelatedGraphChart>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs12>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Hashtag River</div>
              <v-dialog style="float: right" v-model="hashtagsTweetsRiverChartDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">Hashtag Graph</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullHashtagsTweetsRiverChart'], 'FullHashtagsTweetsRiverChart')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn icon dark @click.native="hashtagsTweetsRiverChartDialog = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullHashtagsTweetsRiverChart" ref="FullHashtagsTweetsRiverChart" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center;padding-top:20px" v-if="hashtagsTweetsRiverChartDialog">
                    <HashtagsTweetsRiverChart v-bind:options="{}" v-bind:filters="getFilters"></HashtagsTweetsRiverChart>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn style="float: right; width: 30px" flat icon color="primary" class="mx-0" @click.stop="snap($refs['HashtagsTweetsRiverChart'], 'HashtagsTweetsRiverChart')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="height: 400px">
              <v-card-text id="HashtagsTweetsRiverChart" ref="HashtagsTweetsRiverChart" style="height: 100%">
                <HashtagsTweetsRiverChart v-bind:options="{}" v-bind:filters="getFilters"></HashtagsTweetsRiverChart>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs12>
        <v-toolbar class="elevation-1 secondary" >
          <v-toolbar-side-icon><v-icon>fas fa-hashtag</v-icon></v-toolbar-side-icon>
          <v-toolbar-title>Hashtags</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-flex xs3>
            <v-select
              v-model="sortBy"
              :items="hashtagSort"
              hide-details
              item-text="text"
              item-value="value"
              label="Sort by"
              :menu-props="{maxHeight:'900'}">
              <template slot="selection" slot-scope="{ item, tile }">
                <span><v-icon :color="item.color" small class="mr-2">{{ item.icon }}</v-icon>{{ item.text}}</span>
              </template>
              <template slot="item" slot-scope="{ item, tile }">
                <v-list-tile-action>
                  <v-icon :color="item.color">{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title v-text="item.text"></v-list-tile-title>
                </v-list-tile-content>
              </template>
            </v-select>
          </v-flex>
          <v-tooltip bottom>
            <v-avatar slot="activator">
              <v-icon v-bind:class="[orderBy === 'ASC' ? 'ascending' : 'descending']" @click="orderChange">arrow_downward</v-icon>
            </v-avatar>
            <span>Ascending / Descending Order</span>
          </v-tooltip>
        </v-toolbar>
        <v-card>
          <v-card-text class="pa-0">
            <center>
              <HashtagsListing v-bind:options="{sortBy: sortBy, orderBy: orderBy}" v-bind:filters="getFilters"></HashtagsListing>
            </center>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style>
  .ascending {
    transform: rotate(-180deg);
    transition: 0.2s all ease-in-out;
  }
  .descending {
    transform: rotate(0deg);
    transition: 0.2s all ease-in-out;
  }
</style>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { snap } from '@/helpers/snapshots'
import Filters from './Filters.vue'
import Counters from './Counters.vue'
import HashtagCloud from './clouds/HashtagCloud.vue'
import HashtagsTweetsRiverChart from './charts/HashtagsTweetsRiverChart.vue'
import HashtagsListing from './listings/HashtagsListing.vue'
import HashtagsRelatedGraphChart from './charts/HashtagsRelatedGraphChart.vue'

export default {
  data () {
    return {
      hashtagSort: [
        {color: 'blue lighten-3', icon: 'fab fa-twitter ', text: 'Tweets', value: '_tweet_count'},
        {color: 'green lighten-2', icon: 'fas fa-retweet', text: 'Retweet', value: '_retweet_count'},
        {color: 'red lighten-2', icon: 'fas fa-heart', text: 'Favorite', value: '_favorite_count'},
        {color: 'blue lighten-2', icon: 'fas fa-comment', text: 'Reply', value: '_reply_count'},
        {color: 'teal lighten-2', icon: 'fas fa-quote-right', text: 'Quote Tweet', value: '_quote_count'},
        {color: 'orange lighten-2', icon: 'fas fa-calendar', text: 'Date', value: '_created_at'}
      ],
      menu: false,
      dialogMenu: false,
      hashtagLimits: [25, 35, 50, 75, 100],
      hashtagLimit: 35,
      sortBy: '_tweet_count',
      sortGraph: '_tweet_count',
      singles: 'singles',
      layout: 'circular',
      orderBy: 'DESC',
      expansionValue: 0,
      hashtagCloudDialog: false,
      hashtagsRelatedGraphChartDialog: false,
      hashtagsTweetsRiverChartDialog: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters('toggles', ['getFiltersChips']),
    ...mapGetters('filters', ['getFilters']),
    sortByGraph () {
      for (let x = 0; x < this.hashtagSort.length; x++) {
        if (this.hashtagSort[x].value === this.sortGraph) {
          return 'Sorted by: ' + this.hashtagSort[x].text
        }
      }
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setFilters', 'resetFilters']),
    snap,
    orderChange () {
      this.orderBy = this.orderBy === 'DESC' ? 'ASC' : 'DESC'
    }
  },
  components: {
    Filters,
    Counters,
    HashtagCloud,
    HashtagsTweetsRiverChart,
    HashtagsListing,
    HashtagsRelatedGraphChart
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Hashtags.vue